
import AdminHeader from '../../components/adminHeader';
import AdminFooter from '../../components/adminFooter';

const AdminProfile = () => {
  return (
    <div className="w-full h-full flex flex-col bg-gray-900 font-mono text-white">
      <AdminHeader />
      <div className="flex-grow flex flex-col items-center justify-center w-full">
        <h1 className="text-4xl font-bold mb-8 text-center text-yellow-400 drop-shadow-lg">Admin Profile</h1>
        {/* Profile content will go here */}
      </div>
      <AdminFooter />
    </div>
  );
};

export default AdminProfile;
